import React from "react"

import classNames from "classnames"

import { Tooltip } from "shared/ui/tooltip/Tooltip"

interface ProductPositionTableCellProps
  extends React.HTMLProps<HTMLDivElement> {
  isHeader?: boolean
  isTooltipDisabled?: boolean
  tooltip?: React.ReactNode
  tooltipClassName?: string
}

export const ProductPositionTableCell = React.memo(
  React.forwardRef(
    (
      {
        children,
        className,
        isHeader,
        isTooltipDisabled,
        tooltip,
        tooltipClassName = "table-row-cell__tooltip",
        ...rest
      }: ProductPositionTableCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      return (
        <Tooltip
          content={
            tooltip ? <div className={tooltipClassName}>{tooltip}</div> : null
          }
          disabled={isTooltipDisabled}
          placement="top"
          sideOffset={8}
        >
          <div
            ref={ref}
            role={isHeader ? "rowheader" : "gridcell"}
            className={classNames("table-row-cell", className)}
            {...rest}
          >
            {children}
          </div>
        </Tooltip>
      )
    }
  )
)
